import { render, staticRenderFns } from "./SynchronizationColumn.vue?vue&type=template&id=687be6a2&scoped=true&"
import script from "./SynchronizationColumn.vue?vue&type=script&lang=js&"
export * from "./SynchronizationColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687be6a2",
  null
  
)

export default component.exports